import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ISelectedAllPayment } from '../hooks/useSetTotalPayment'

interface IFooterProps {
    commission: number
    total: number
    toBePaidTransactions: ISelectedAllPayment[]
}

export default function FooterAllPayGateway({
    commission,
    total,
    toBePaidTransactions,
}: IFooterProps) {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const { id } = useParams()
    const isMoneyPool = pathname.includes('money-pool')
    return (
        <div className=" mb-2 w-full">
            <div className=" bg-white shadow-[0px 9px 29px 0px rgba(0, 0, 0, 0.2)] rounded-xl px-3 py-3 mx-4">
                <div className=" flex justify-between">
                    <p className=" text-gray-4">هزینه‌ی اشتراک:</p>
                    <p>{commission.toLocaleString()} تومان</p>
                </div>
                <hr className=" my-2" />
                <div className=" flex justify-between">
                    <p className="text-green-1">مبلغ کل:</p>
                    <p className=" text-green-1">
                        {total.toLocaleString()} تومان
                    </p>
                </div>
            </div>
            <div
                className=" mx-8 rounded-3xl  bg-green-1 text-white text-center py-2 my-2 cursor-pointer"
                onClick={() =>
                    isMoneyPool
                        ? navigate(`/easy-pay/money-pool/${id}`, {
                              state: {
                                  total: total,
                                  commission: commission,
                                  toBePaidTransactions,
                              },
                          })
                        : navigate('/easy-pay/init-new', {
                              state: {
                                  total: total,
                                  commission: commission,
                                  toBePaidTransactions,
                              },
                          })
                }
            >
                پرداخت
            </div>
            <p
                className="  text-center  text-gray-4 text-lg mt-1 cursor-pointer"
                onClick={() => navigate(-1)}
            >
                بعدا
            </p>
        </div>
    )
}
